(() => {
    'use strict';

    angular
        .module('uwAgenda.agenda')
        .directive(
            'agendaDaytaskSharedAgendas',
            [
                'SharedAgendaService',
                buildDirective
            ]
        );

    function buildDirective(SharedAgendaService) {
        return {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-daytask-sharedagendas.template.html',
            scope: {
                selectedAgendas: '='
            },
            link: link
        };

        function link(scope, element) {
            initialize(scope);
        }

        function initialize(scope) {
            const data = SharedAgendaService && SharedAgendaService.data;
            if (!data) return;

            if (Array.isArray(data.agendas)) {
                scope.agendas = data.agendas;
            }
            
            if (data.currentAgenda) {
                scope.defaultAgenda = data.currentAgenda;
            }

            scope.selectedAgendas = scope.selectedAgendas || [];
            if (scope.defaultAgenda) {
                scope.selectedAgendas.push(scope.defaultAgenda);
            }

            scope.isSelected = function (agenda) {
                return scope.selectedAgendas.some(function(a) {
                    return a.id === agenda.id;
                });
            };

            scope.selectAgenda = function (agenda) {
                const idx = scope.selectedAgendas.findIndex(a => a.id === agenda.id);
                if (idx > -1) {
                    scope.selectedAgendas.splice(idx, 1);
                } else {
                    scope.selectedAgendas.push(agenda);
                }
                console.log(scope.selectedAgendas);
            };
        }
    }
})();